/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable, Inject } from '@angular/core';
import _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class KeysetFeedStoreService {
  constructor(@Inject('AlertService') private alertService: any) {}

  create(fetchFeed: Function, storeParameters?: object): any {
    const { alertService } = this;
    let latestHeaders: any;
    let inflightPromise: any = null;

    // Use a named constructor so lodash isPlainObject() returns false — see feed-store.service.ts
    function KeysetFeedStoreResult() {}
    const store: any = new (KeysetFeedStoreResult as any)();
    store.parameters = {};
    store.fetchFeed = fetchFeed;
    store.feedItems = [];
    store.isLastPage = true;
    store.isLoading = false;

    // Returned only for the settled no-op path (loadMore on last page).
    const selfPromise = {
      then(callback: Function) { callback(store); },
    };

    const handleResponse = (response: any) => {
      try {
        latestHeaders = response.headers;
        Array.prototype.push.apply(store.feedItems, response.data);
        store.isLastPage = typeof latestHeaders === 'function' ? !latestHeaders('X-Next-Id') : true;
      } finally {
        store.isLoading = false;
        inflightPromise = null;
      }
      return response;
    };

    const handleErrorResponse = (response: any) => {
      alertService.addDanger(response.statusText);
      store.isLoading = false;
      inflightPromise = null;
    };

    const doFetch = (nextId?: any) => {
      if (store.isLoading) return inflightPromise;
      const pagination = { after_id: nextId, per_page: 10 };
      const parameters = _.merge({}, pagination, storeParameters, store.parameters);
      store.isLoading = true;
      inflightPromise = store.fetchFeed(parameters).then(handleResponse, handleErrorResponse).then(() => store);
      return inflightPromise;
    };

    store.reset = () => { store.feedItems = []; };
    store.load = (nextId?: any) => { store.feedItems = []; return doFetch(nextId); };
    store.loadMore = (nextId?: any) => {
      if (_.isEmpty(store.feedItems)) return store.load(nextId);
      nextId = typeof latestHeaders === 'function' ? latestHeaders('X-Next-Id') : undefined;
      if (nextId) return doFetch(nextId);
      return selfPromise;
    };

    return store;
  }
}
